export const serviceName = 'newEntityOptions';
